var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoEssentia21AnosBr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_essentia_21_anos_ESP",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 425.2,
    height: 425.2,
    viewBox: "0 0 425.2 425.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1272",
    "data-name": "Ret\\xE2ngulo 1272",
    width: 311.508,
    height: 292.534,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1",
    "data-name": "Ret\\xE2ngulo 1",
    width: 425.2,
    height: 425.2,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1983",
    "data-name": "Grupo 1983",
    transform: "translate(66.6 66.086)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1268",
    "data-name": "Ret\\xE2ngulo 1268",
    width: 7.994,
    height: 7.997,
    transform: "matrix(0.596, -0.803, 0.803, 0.596, 5.747, 184.469)",
    fill: "none",
    stroke: "#b1965e",
    strokeMiterlimit: 10,
    strokeWidth: 0.654
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_846",
    "data-name": "Caminho 846",
    d: "M43.2,37.089,38.535,54.812c-.336,1.3-.329,2.221.488,2.214,1.056,0,2.781-2.416,3.786-4.492l1.015.715c-1.773,3.715-4.022,6.8-8.066,6.815-2.745,0-3.472-1.963-2.473-5.623l1.091-3.853h-.145c-2.2,4.094-5.938,9.5-11.228,9.514-3.322,0-4.2-2.585-4.208-5.521-.014-5.957,4.856-17.821,15.488-17.852a6.333,6.333,0,0,1,3.322.855l.191-.477Zm-8.468,1.277c-5.681.014-9.874,11.342-9.862,16.3,0,1.494.346,2.411,1.446,2.4,3.336,0,7.916-8.5,9.531-13.648.477-1.544,1.006-3.336,1.294-4.434a4.613,4.613,0,0,0-2.411-.617",
    transform: "translate(78.016 152.448)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_847",
    "data-name": "Caminho 847",
    d: "M24.1,60.066l4.661-18.495c.381-1.442.329-1.925-.679-2.013l-2.652-.238.288-1.206,9.719-1.33.191.2L32.768,46.61h.2c2.824-5.206,6.993-9.888,11.564-9.9,3.812-.014,4.244,3.064,3.148,6.629L44.2,54.757c-.381,1.251-.376,2.214.438,2.209,1.108,0,2.833-2.364,3.986-4.487l1.108.715c-1.773,3.708-4.075,6.846-8.261,6.855-2.642,0-3.812-1.963-2.859-5.187l3.574-12.283c.427-1.446.422-2.793-.975-2.793-2.5,0-6.2,5.218-7.916,9.174A70.631,70.631,0,0,0,29.68,59.508Z",
    transform: "translate(100.027 152.372)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_848",
    "data-name": "Caminho 848",
    d: "M52.042,45.137a18.242,18.242,0,0,1-2.724,9.433A12.057,12.057,0,0,1,38.6,60.051c-6.355.021-9.014-3.481-9.028-8.39C29.547,44.775,34.193,36.724,43.1,36.7c4.327-.014,8.9,1.668,8.926,8.442M35.4,54.435c0,2.647.975,4.084,3.045,4.084C43.593,58.5,46.2,45.89,46.195,42.554c0-2.4-.541-4.332-2.9-4.322-5.294.014-7.906,11.959-7.892,16.2",
    transform: "translate(122.736 152.322)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_849",
    "data-name": "Caminho 849",
    d: "M52.212,40.469a2.69,2.69,0,0,1-2.545,2.514,1.52,1.52,0,0,1-1.544-1.056c-1.06-2.55-2.075-3.605-3.615-3.6-1.4,0-2.266.922-2.256,2.559,0,1.3.731,2.695,3.77,5.042,2.75,2.2,4.248,3.831,4.26,6.672,0,3.848-3.348,7.422-9.076,7.437-5.2.014-7.036-2.719-7.041-4.5a2.914,2.914,0,0,1,2.735-2.8,1.546,1.546,0,0,1,1.544,1.148c1.4,3.174,3.281,4.413,4.766,4.413a2.261,2.261,0,0,0,2.447-2.559c0-1.73-1.649-3.605-3.812-5.378-2.221-1.875-4.051-3.548-4.065-6.386-.014-4,3.1-7.277,8.5-7.294,4.187-.014,5.924,2.383,5.928,3.781",
    transform: "translate(141.807 152.263)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_850",
    "data-name": "Caminho 850",
    d: "M65.766,21.118a27.457,27.457,0,0,0-17.08-5.054,32.07,32.07,0,0,0-13.5,2.683,23.113,23.113,0,0,0-8.869,6.717A12.967,12.967,0,0,0,23.3,33.232a5.059,5.059,0,0,0,1.38,3.7,4.894,4.894,0,0,0,6.86.014,4.73,4.73,0,0,0,1.334-3.357,6.329,6.329,0,0,0-1.57-4.558l-.407-.434.238-.546a13.994,13.994,0,0,1,6-6.572,18.109,18.109,0,0,1,9.374-2.54c5.635,0,9.7,1.885,12.1,5.6a23.713,23.713,0,0,1,3.1,14.039,26.6,26.6,0,0,1-4.935,13.053A73.213,73.213,0,0,1,44.815,65.366H44.8L40.55,68.993c-4.806,4.141-8.616,7.67-11.325,10.484a39.883,39.883,0,0,0-6.815,9.662,30.07,30.07,0,0,0-3.055,11.394H69.924l1.508-14.809H69.526a7.823,7.823,0,0,1-3.874,6.643,22.748,22.748,0,0,1-10.3,1.787c-3.162,0-5.666-.041-7.437-.119l-21.066-.6L25.731,93.4l.257-1.091a25.734,25.734,0,0,1,6.638-11.077A113.062,113.062,0,0,1,47.043,68.65c15.786-12.133,24.066-22.815,24.6-31.736.386-7.191-1.6-12.5-5.888-15.793",
    transform: "translate(80.335 66.603)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_851",
    "data-name": "Caminho 851",
    d: "M52.509,97.567l.238-1.153a58.432,58.432,0,0,0,.715-8.163l3.708-72.2H54.31L31.586,32.732l1.277,2.111,14-8.788.222-.138h1.453l-.041.953L45.828,83.754A18.807,18.807,0,0,1,42.856,94.32a10.884,10.884,0,0,1-8.34,3.991l-.067,2.209H62.712l.155-3.436-9.183.434Z",
    transform: "translate(131.09 66.619)",
    fill: "#b3965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_852",
    "data-name": "Caminho 852",
    d: "M102.932,88.608l21.659-21.652L106.646,49.033l-7.21,7.21-3.719-3.724,7.215-7.215-7.217-7.222,3.719-3.724,7.232,7.227,10.722-10.722L106.665,20.139l-7.222,7.222-3.715-3.715,10.944-10.939,16.7,16.7V51.292l-9.483-9.469-3.5,3.5,17.923,17.935V27.376L106.661,5.717,88.738,23.661l7.2,7.2-3.719,3.719-7.222-7.215-7.213,7.217-3.724-3.722,7.227-7.229L70.562,12.91,59.839,23.633l7.227,7.229-3.715,3.708L52.408,23.63l16.7-16.7H91l-9.474,9.481L85.013,19.9,102.948,1.978H67.064L45.412,23.63,63.356,41.553l7.205-7.2,3.724,3.724-7.22,7.22,7.215,7.215-3.719,3.724-7.227-7.232L52.612,59.731,63.335,70.454l7.227-7.222,3.715,3.715L63.337,77.886l-16.7-16.7V39.3l9.483,9.483,3.484-3.5L41.678,27.352v35.88L63.337,84.891,81.26,66.946l-7.21-7.205,3.724-3.724,7.215,7.215,7.222-7.215,3.719,3.724L88.7,66.968,99.427,77.69l10.722-10.722-7.222-7.215,3.715-3.715,10.939,10.939L100.887,83.664H79l9.476-9.476-3.493-3.5L67.054,88.608h35.877Zm3.724-61.475,3.729,3.729-3.719,3.724-3.734-3.724ZM66.84,23.644l3.722-3.729,3.724,3.719-3.724,3.731Zm-3.5,39.814L59.6,59.729,63.325,56l3.734,3.734ZM85,34.357l3.724,3.724L85,41.806l-3.712-3.724ZM77.782,49.021,74.057,45.3l3.724-3.717,3.724,3.724ZM85,56.243l-3.712-3.724L85,48.794l3.724,3.724Zm3.5-10.939,3.724-3.719,3.724,3.724-3.724,3.719Zm14.663,21.652-3.729,3.729L95.7,66.965l3.729-3.734Z",
    transform: "translate(172.997 8.218)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_853",
    "data-name": "Caminho 853",
    d: "M146.726,31.348,115.386,0H71.043L39.7,31.348V75.684l31.343,31.345h44.343l31.34-31.345Zm-4.939,42.28-28.46,28.457H73.1L44.642,73.627V33.4L73.1,4.944h40.228L141.787,33.4Z",
    transform: "translate(164.781)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_854",
    "data-name": "Caminho 854",
    d: "M10.548,57.98,9.9,59.8,6.826,58.628l.715-1.987a9.591,9.591,0,0,1-2.793-3.117,8.621,8.621,0,0,1,3.26-12.178A8.616,8.616,0,0,1,20.17,44.682,8.621,8.621,0,0,1,16.929,56.9a8.871,8.871,0,0,1-6.386,1.082M8.73,53.326l1.015-2.838L12.8,51.68l-1.015,2.833a6.133,6.133,0,0,0,3.276-.87A5.228,5.228,0,1,0,9.869,44.6a5.2,5.2,0,0,0-2.3,7.313,5.02,5.02,0,0,0,1.165,1.411",
    transform: "translate(14.292 166.276)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_855",
    "data-name": "Caminho 855",
    d: "M16.77,43.294l2.359,2.859-7.863,6.491a3.677,3.677,0,0,0-.581,5.654,3.66,3.66,0,0,0,5.63.465l7.863-6.491,2.364,2.859-7.947,6.553c-3.3,2.731-7.1,2.7-10.41-1.325s-2.642-7.8.617-10.484Z",
    transform: "translate(24.909 179.697)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_856",
    "data-name": "Caminho 856",
    d: "M19.743,61.638,14,56.539l-2.781,1.508L8.206,55.369l16.389-8.456,3.436,3.05L21.583,67.226l-2.993-2.64Zm-2.914-6.819L21.1,58.6l3.112-7.794Z",
    transform: "translate(34.059 194.718)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_857",
    "data-name": "Caminho 857",
    d: "M21.344,48.821l3.05,2.018-7.706,11.64,6.052,4.008-1.773,2.688-9.112-6.031Z",
    transform: "translate(49.209 202.636)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1269",
    "data-name": "Ret\\xE2ngulo 1269",
    width: 17.163,
    height: 3.655,
    transform: "translate(76.503 275.297) rotate(-62.279)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_858",
    "data-name": "Caminho 858",
    d: "M23.015,51.388,29.355,53.8a8.607,8.607,0,1,1-6.078,16.06l-6.336-2.395Zm1.4,15.457a5.147,5.147,0,0,0,6.934-3.1A5.03,5.03,0,0,0,28.214,56.8l-2.919-1.1L21.5,65.758Z",
    transform: "translate(70.311 213.291)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_859",
    "data-name": "Caminho 859",
    d: "M33.858,68.031l-7.5-1.57-1.668,2.673-3.924-.829L30.77,52.884l4.475.936,2.945,18.152-3.905-.82Zm-5.9-4.465,5.564,1.17-1.153-8.287Z",
    transform: "translate(86.179 219.501)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_860",
    "data-name": "Caminho 860",
    d: "M26.25,53.4l6.762.3a8.6,8.6,0,1,1-.762,17.156l-6.767-.3Zm6.14,14.237A5.144,5.144,0,0,0,38,62.528a5.025,5.025,0,0,0-5.135-5.614l-3.117-.133L29.276,67.5Z",
    transform: "translate(105.769 221.656)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_861",
    "data-name": "Caminho 861",
    d: "M29.74,54.513l12.078-1.287.329,3.117-8.442.9.4,3.708,8.261-.882L42.7,63.2l-8.261.882.422,3.965,8.442-.905.336,3.152L31.563,71.576Z",
    transform: "translate(123.44 220.918)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_862",
    "data-name": "Caminho 862",
    d: "M52.491,64.378l1.668.967-1.711,2.812-1.828-1.082a9.615,9.615,0,0,1-3.574,2.173,8.608,8.608,0,1,1,5.454-4.87m-4.9.922L44.99,63.792l1.725-2.785,2.6,1.515a6.143,6.143,0,0,0-.253-3.374A5.211,5.211,0,1,0,47.6,65.3",
    transform: "translate(146.476 215.598)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_863",
    "data-name": "Caminho 863",
    d: "M39,57.08l3.245-1.792,4.93,8.926a3.967,3.967,0,1,0,6.948-3.832l-4.93-8.931,3.245-1.787,4.975,9.024c2.071,3.734,1.334,7.468-3.224,9.981-4.594,2.535-8.163,1.153-10.2-2.554Z",
    transform: "translate(161.874 206.136)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_864",
    "data-name": "Caminho 864",
    d: "M42.544,55l9.612-7.437,1.921,2.488-6.717,5.2L49.642,58.2l6.576-5.09,1.925,2.483-6.576,5.094,2.442,3.16,6.717-5.2,1.942,2.5-9.612,7.437Z",
    transform: "translate(176.584 197.431)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_865",
    "data-name": "Caminho 865",
    d: "M54.928,59.234a7.537,7.537,0,0,0,5.29-2.7c1.287-1.544,1.191-2.909.434-3.538-.989-.824-2.283.041-3.915,1.263-2.3,1.747-5.206,4.013-8.154,1.551-2.195-1.835-2.383-5.242.212-8.34a9.531,9.531,0,0,1,6.145-3.6l.741,3.281a7.327,7.327,0,0,0-4.6,2.564c-1.056,1.268-1.065,2.4-.279,3.064.891.746,2.092-.129,3.724-1.361,2.318-1.756,5.285-3.982,8.216-1.53,2.411,2.025,2.793,5.264-.191,8.816a9.919,9.919,0,0,1-6.779,3.836Z",
    transform: "translate(194.633 182.099)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_866",
    "data-name": "Caminho 866",
    d: "M48.757,51.049,55.21,40.727l2.669,1.668-4.506,7.222L56.539,51.6l4.415-7.063L63.628,46.2,59.2,53.267l3.4,2.123,4.513-7.222L69.8,49.853l-6.46,10.322Z",
    transform: "translate(202.372 169.042)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_867",
    "data-name": "Caminho 867",
    d: "M51.2,51.976l1.365-3.946L66.6,47.866l-10.92-8.8,1.365-3.934L71.091,47l-1.5,4.332Z",
    transform: "translate(212.5 145.8)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1270",
    "data-name": "Ret\\xE2ngulo 1270",
    width: 3.65,
    height: 17.165,
    transform: "matrix(0.216, -0.976, 0.976, 0.216, 270.343, 176.584)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_868",
    "data-name": "Caminho 868",
    d: "M52.858,47.045l.407-4.153,13.6-3.445L54.192,33.434l.407-4.141,16.441,8.252-.45,4.565Z",
    transform: "translate(219.394 121.586)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_869",
    "data-name": "Caminho 869",
    d: "M53.662,38.978l-.624-12.14,3.136-.164.438,8.492,3.729-.191-.427-8.313,3.136-.16.427,8.309,3.991-.212-.438-8.487,3.162-.15L70.816,38.1Z",
    transform: "translate(220.145 107.757)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_870",
    "data-name": "Caminho 870",
    d: "M0,39.183l.124-12.14,3.148.026-.093,8.5,3.734.036L7,27.291l3.136.036-.088,8.313,3.991.031.088-8.492,3.162.036-.133,12.145Z",
    transform: "translate(0 112.246)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_871",
    "data-name": "Caminho 871",
    d: "M11.683,36.26A7.532,7.532,0,0,0,14.8,31.218c.3-1.982-.477-3.1-1.453-3.241-1.272-.2-1.932,1.21-2.688,3.1C9.591,33.751,8.288,37.2,4.492,36.61,1.676,36.183-.24,33.391.372,29.4a9.531,9.531,0,0,1,3.374-6.248l2.33,2.411a7.3,7.3,0,0,0-2.6,4.575c-.238,1.623.336,2.595,1.349,2.754,1.148.174,1.716-1.191,2.473-3.081,1.065-2.7,2.452-6.128,6.212-5.557,3.1.477,5.109,3.05,4.4,7.625a9.888,9.888,0,0,1-3.8,6.784Z",
    transform: "translate(1.069 96.096)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_872",
    "data-name": "Caminho 872",
    d: "M11.71,33.463A7.484,7.484,0,0,0,15.5,28.914c.586-1.921-.041-3.131-.984-3.419-1.225-.372-2.075.936-3.1,2.7-1.43,2.492-3.21,5.719-6.877,4.611C1.807,31.981.3,28.948,1.473,25.081A9.531,9.531,0,0,1,5.7,19.362l1.978,2.719a7.308,7.308,0,0,0-3.219,4.156c-.477,1.57-.041,2.621.953,2.921,1.113.329,1.875-.953,2.89-2.7,1.43-2.535,3.286-5.733,6.934-4.634,3.007.913,4.625,3.739,3.281,8.173A9.841,9.841,0,0,1,13.8,36.177Z",
    transform: "translate(4.457 80.376)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_873",
    "data-name": "Caminho 873",
    d: "M2.126,26.7l5.1-11.049,2.859,1.318L6.515,24.7l3.4,1.57L13.4,18.7l2.859,1.318-3.488,7.565L16.4,29.254l3.574-7.732,2.874,1.334L17.738,33.915Z",
    transform: "translate(8.825 64.984)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_874",
    "data-name": "Caminho 874",
    d: "M10.58,24.675l9.626,6.376L18.188,34.1,3.865,24.613,5.94,21.482l13.67-.5-9.293-6.133,2.025-3.055,14.323,9.483-1.947,2.94Z",
    transform: "translate(16.038 48.962)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_875",
    "data-name": "Caminho 875",
    d: "M12.166,17.275,8.8,21,6.414,18.836l9.2-10.158L18,10.842l-3.357,3.7,10.348,9.379-2.473,2.726Z",
    transform: "translate(26.613 36.02)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1271",
    "data-name": "Ret\\xE2ngulo 1271",
    width: 3.653,
    height: 17.175,
    transform: "translate(47.379 39.935) rotate(-41.838)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_876",
    "data-name": "Caminho 876",
    d: "M24.931,15.955l-6.31,4.4.815,3.05-3.3,2.3L11.74,7.789,15.5,5.168,30.8,15.49l-3.281,2.283Zm-7.32,1.237,4.673-3.264L15.438,9.078Z",
    transform: "translate(48.727 21.445)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_877",
    "data-name": "Caminho 877",
    d: "M22.9,2.725a8.025,8.025,0,0,1,7.985.927L28.643,6.29a4.839,4.839,0,0,0-4.568-.541,5.34,5.34,0,0,0-2.976,7.2,5.345,5.345,0,0,0,7.055,3.307,5.776,5.776,0,0,0,2.99-2.571l-.758-1.942-4.27,1.668-1.139-2.931L32.6,7.514l2.383,6.119a9.6,9.6,0,0,1-5.647,5.673,8.745,8.745,0,0,1-11.737-5A8.7,8.7,0,0,1,22.9,2.713",
    transform: "translate(70.293 8.576)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_878",
    "data-name": "Caminho 878",
    d: "M29.5,12.249l-2.621.567,1.3,6.012-3.574.784L20.979,2.823l7.854-1.689a5.342,5.342,0,0,1,6.81,4.182,4.935,4.935,0,0,1-2.595,5.778l5.161,5.569-4.105.886Zm-.536-7.942-3.75.82,1.006,4.625,3.75-.815a2.383,2.383,0,1,0-1.006-4.63",
    transform: "translate(87.077 3.811)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_879",
    "data-name": "Caminho 879",
    d: "M33.543.382A8.637,8.637,0,0,1,43,8.767a8.633,8.633,0,0,1-8.495,9.359,8.623,8.623,0,0,1-9.431-8.385A8.628,8.628,0,0,1,33.543.382m.181,3.241a5.2,5.2,0,0,0-4.889,5.912,5.228,5.228,0,1,0,10.41-.567,5.213,5.213,0,0,0-5.521-5.352",
    transform: "translate(103.983 1.45)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_880",
    "data-name": "Caminho 880",
    d: "M30.971.376,34.65.788,33.5,10.929a3.967,3.967,0,1,0,7.88.9L42.544,1.689,46.23,2.1,45.062,12.347c-.488,4.244-3.25,6.865-8.411,6.274-5.228-.586-7.325-3.786-6.846-7.985Z",
    transform: "translate(123.435 1.561)",
    fill: "#b1965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_881",
    "data-name": "Caminho 881",
    d: "M38.248,1.059,45.98,3.2a5.359,5.359,0,0,1,4.079,6.865,5.347,5.347,0,0,1-7.015,3.739l-4.213-1.165L37.2,18.551l-3.517-.979Zm6.433,5.032L40.938,5.057,39.678,9.62l3.739,1.029a2.371,2.371,0,1,0,1.263-4.558",
    transform: "translate(139.813 4.395)",
    fill: "#b1965e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEssentia21AnosBr);
export default __webpack_public_path__ + "static/media/logo_essentia_21_anos_BR.9b54325184268d72c8c1cd67a5f709ab.svg";
export { ForwardRef as ReactComponent };